const constants = {
  EMPLOYEE_DETAILS: "EMPLOYEE_DETAILS",
  EMPLOYEE_AUTH: "EMPLOYEE_AUTH",
  EMPLOYEE_LEAVE_DETAIL: "EMPLOYEE_LEAVE_DETAIL",
  EMPLOYEE_ALL_DETAILS: "EMPLOYEE_ALL_DETAILS",
  EMPLOYEE_SELECTED_INDEX: "EMPLOYEE_SELECTED_INDEX",
  EMPLOYEE_HOLIDAY: "EMPLOYEE_HOLIDAY",
  ASSET_MANAGEMENT: "ASSET_MANAGEMENT",
  ASSET_ASSIGN_MANAGEMENT: "ASSET_ASSIGN_MANAGEMENT",
  ITEM_ASSET_HEADER_SELECT: "ITEM_ASSET_HEADER_SELECT",
  ADD_CUSTOMER: "ADD_CUSTOMER",
  REPORTING_MANAGER: "REPORTING_MANAGER",
  ADD_DEPARTEMENT: "ADD_DEPARTEMENT",
  MONTHLY_ATTENDANCE: "MONTHLY_ATTENDANCE",
  ALLU_USER_ATTENDANCE: "ALLU_USER_ATTENDANCE",
  ALL_INVOICE: "ALL_INVOICE",
  ALL_INACTIVE_EMPLOYEE: "ALL_INACTIVE_EMPLOYEE",
  WEEK_ON_OFF: "WEEK_ON_OFF",
  WORK_FROM_HOME: "WORK_FROM_HOME",
  GIFT_CARD_SHOW:'GIFT_CARD_SHOW',
  LEAVE_WFH_REQUEST: "LEAVE_WFH_REQUEST",
};

export default constants;
